import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, BoxProps } from "@material-ui/core";

export const Link: React.FC<BoxProps & { to: string }> = ({ to, onClick, children, ...props }) => (
    <RouterLink to={to} onClick={onClick} style={{ textDecoration: "none" }}>
        <Box {...props}>{children}</Box>
    </RouterLink>
);
